export const FALLBACK_TO_BOOTDATA_WARNING = `PluginMeta: plugin meta yielded an empty result so Grafana is falling back to bootdata`;
